import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KtSelectComponent } from './kt-select.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [KtSelectComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatCheckboxModule
  ],
  exports: [KtSelectComponent]
})
export class KtSelectModule { }
